document.addEventListener('click', (e) => {

  const tabsBtn = e.target.closest('.tabs-btn')
  const accordionBtn = e.target.closest('.tabs-accordion-trigger')

  if (tabsBtn) {

    const tabs = tabsBtn.closest('[data-tabs]')
    const id = tabsBtn.dataset.tab

    tabs.querySelectorAll('.tabs-btn').forEach(b => b.classList.remove('is-active'))
    tabs.querySelectorAll('.tabs-pane').forEach(p => p.classList.remove('is-active'))

    tabsBtn.classList.add('is-active')
    tabs.querySelector('.tabs-pane[data-pane="'+id+'"]').classList.add('is-active')

  }

  if (accordionBtn) {

    const pane = accordionBtn.closest('.tabs-pane')
    const willOpen = !pane.classList.contains('is-active')

    pane.classList.toggle('is-active')

    if (willOpen) {

      requestAnimationFrame(() => {

        const offset = 20
        const y = pane.getBoundingClientRect().top + window.scrollY - offset

        window.scrollTo({
          top: y,
          behavior: 'smooth'
        })

      })

    }

  }

})
